import { useMutation } from "@tanstack/react-query";
import { GET_FAMILY } from "./endpoints";
import { getRequest } from "./axiosClient";

export const useGetFamily = () => {
	return useMutation({
		mutationFn: ({
			id_persona,
			dniFamiliar,
			tokenSeguridad,
			supervisorDNI,
		}) => {
			return getRequest(
				`${GET_FAMILY}?idp=${id_persona}&ndf=${dniFamiliar}&tks=${tokenSeguridad}${
					supervisorDNI ? `&s=${supervisorDNI}` : ""
				}`
			);
		},
	});
};
